import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/api/client";
import type { PmvvSettings } from "@/types";

export function usePMVV() {
  return useQuery<PmvvSettings>({
    queryKey: ["settings", "pmvv"],
    queryFn: async () => {
      const res = await apiClient.get<PmvvSettings>("/settings/pmvv");
      return res.data;
    },
  });
}

export function useUpdatePMVV() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: Omit<PmvvSettings, "updated_at">) => {
      const res = await apiClient.put<PmvvSettings>("/settings/pmvv", data);
      return res.data;
    },
    onSuccess: (data) => {
      qc.setQueryData(["settings", "pmvv"], data);
      // PMVV change regenerates the canonical KB article — invalidate so
      // KB list/search picks it up.
      qc.invalidateQueries({ queryKey: ["kb"] });
    },
  });
}
